import Phaser from 'phaser';
import GameScreen from '../scenes/GameScreen';
import ABCyaPhaser from '@abcya/abcya_phaser';
import UIAssetKeys from '../UIAssetKeys';
import ConfirmDialog from '../common/ConfirmDialog';
import SoundAssetKeys from '../SoundAssetKeys';
import SaveCreationPictureView from './SaveCreationPictureView';
import ABCyaLib from '@abcya/abcya_lib';
import LocalizationSoundAssetKeys from '../Localization-SoundAssetKeys';
import FontKeys from '../FontKeys';

export default class Hud extends Phaser.GameObjects.Container {
  /**
   * 
   * @param {GameScreen} scene 
   */
  constructor(scene, leftBounds, rightBounds) {
    super(scene);

    this.delegate = scene;
    this.leftBounds = leftBounds;
    this.rightBounds = rightBounds;

    this.btnReady = this.scene.add.container(0,0);
    this.add(this.btnReady);
    const readyBg = ABCyaPhaser.Images.addImage(0,0,UIAssetKeys._BUTTON_Ready, this.btnReady);
    ABCyaPhaser.Container.setContainerInteractive(this.btnReady);
    const readyTxt = ABCyaPhaser.Text.addText(0,-10,32, 0xffffff, FontKeys._BPreplay, ABCyaPhaser.Localization.instance.getLocalizedString('game_screen.buttons.ready_button'), this.btnReady).setResolution(1.5);
    ABCyaPhaser.Buttons.convertToButton(this.btnReady, { onClick: () => this.onReadyClick() });

    this.btnStartOver = this.scene.add.container(0,0);
    this.add(this.btnStartOver);
    const startOverBg = ABCyaPhaser.Images.addImage(0,0,UIAssetKeys._BUTTON_StartOver, this.btnStartOver).setOrigin(0);
    this.btnStartOver.setSize(startOverBg.width, startOverBg.height);
    ABCyaPhaser.Container.setContainerInteractive(this.btnStartOver);
    const startOverTxt = ABCyaPhaser.Text.addText(60,84,19, 0xffffff, FontKeys._BPreplay, ABCyaPhaser.Localization.instance.getLocalizedString('game_screen.buttons.start_over_button'), this.btnStartOver).setResolution(1.5)
      .setWordWrapWidth(startOverBg.width - 10)
      .setLineSpacing(-4);
    ABCyaPhaser.Buttons.convertToButton(this.btnStartOver, { onClick: () => this.onStartOverClick() });

    this.btnPicture = this.scene.add.container(0,0);
    this.add(this.btnPicture);
    const pictureBg = ABCyaPhaser.Images.addImage(0,0,UIAssetKeys._BUTTON_Save, this.btnPicture).setOrigin(0);
    this.btnPicture.setSize(pictureBg.width, pictureBg.height);
    ABCyaPhaser.Container.setContainerInteractive(this.btnPicture);
    const picturTxt = ABCyaPhaser.Text.addText(62,95,18, 0xffffff, FontKeys._BPreplay, ABCyaPhaser.Localization.instance.getLocalizedString('game_screen.buttons.save_button'), this.btnPicture).setResolution(1.5);
    ABCyaPhaser.Buttons.convertToButton(this.btnPicture, { onClick: () => this.onShowSavePicture() });

    this.readySound = null;

    const margin = 13;
    const x = this.leftBounds;
    this.readyScale = 1.0;

    this.btnPicture.x = x;
    this.btnPicture.destY = this.scene.scale.height - this.btnPicture.height * this.btnPicture.scaleY;
    this.btnPicture.startY = this.btnPicture.destY + this.btnPicture.height * this.btnPicture.scaleY;
    this.btnPicture.y = this.btnPicture.startY;

    this.btnStartOver.x = this.btnPicture.x + this.btnPicture.width * this.btnPicture.scaleX + margin;
    this.btnStartOver.destY = this.scene.scale.height - this.btnStartOver.height * this.btnStartOver.scaleY;
    this.btnStartOver.startY = this.btnStartOver.destY + this.btnStartOver.height * this.btnStartOver.scaleY;
    this.btnStartOver.y = this.btnStartOver.startY;

    const offset = 300;
    this.btnReady.x = this.scene.scale.width - offset;
    this.btnReady.y = this.btnStartOver.destY;

    this.confirmDialog = null;
    this.confirming = null;

    const sn = ABCyaLib.DEVICE_INFO.desktop ? UIAssetKeys._Mouse_Pointer : UIAssetKeys._Hand_Pointer;
    this.helperHand = ABCyaPhaser.Images.addImage(-1111, 0, sn, this).setOrigin(0);
    this.helperHand.alpha = 0;

    this.prepIntro();
  }

  onReadyClick () {
    this.confirming = 'ready';
    if (!this.confirmDialog) {
      this.confirmDialog = new ConfirmDialog(this.scene, 0xf7efcd, ABCyaPhaser.Localization.instance.getLocalizedString('game_screen.ready_popup_text'), 36, this.confirmAnswer.bind(this));
      this.add(this.confirmDialog);
    }
    this.delegate.stopInstructSound();
    this.readySound = ABCyaPhaser.Audio.createSound(this.scene, 1, false, 0, ABCyaPhaser.Audio.LOCALIZATION_AUDIO_SPRITE);
    ABCyaPhaser.Audio.playSound(LocalizationSoundAssetKeys._Are_you_ready_to_serve_, this.readySound);
  }

  confirmAnswer (value) {
    if (this.readySound) {
      this.readySound.stop();
      this.readySound.destroy();
      this.readySound = null;
    }
    if (this.confirming === 'startover') {
      this.doStartOver(value);
    }
    else if (this.confirming === 'ready') {
      this.doReady(value);
    }
    ABCyaPhaser.Audio.playOneShot(SoundAssetKeys._click, this.scene);
  }

  doStartOver (value) {
    if (value === 'YES') {
      this.delegate.handleStartOver();
    }
    this.confirmDialog.destroy();
    this.confirmDialog = null;
    this.confirming = null;
  }

  doReady (value) {
    if (value === 'YES') {
      this.delegate.beginServing();
    }
    this.confirmDialog.destroy();
    this.confirmDialog = null;
    this.confirming = null;
  }

  onStartOverClick () {
    this.confirming = 'startover';
    if (!this.confirmDialog) {
      this.confirmDialog = new ConfirmDialog(this.scene, 0xf7efcd, ABCyaPhaser.Localization.instance.getLocalizedString('game_screen.start_over_popup_text'), 36, this.confirmAnswer.bind(this));
      this.add(this.confirmDialog);
      ABCyaPhaser.Audio.playOneShot(SoundAssetKeys._save_print_startOver, this.scene);
    }
    ABCyaPhaser.Audio.playOneShot(SoundAssetKeys._click, this.scene);
  }

  async onShowSavePicture () {
    const img = await this.delegate.sayCheese();
    this.saveDialog = new SaveCreationPictureView(this.scene, img, this, this.closeSaveDialog.bind(this));
    this.add(this.saveDialog);
    ABCyaPhaser.Audio.playOneShot(SoundAssetKeys._save_print_startOver, this.scene);
  }

  closeSaveDialog () {
    this.saveDialog.destroy();
    this.saveDialog = null;
  }

  prepIntro () {
    this.btnStartOver.visible = false;
    this.btnPicture.visible = false;
    this.btnReady.visible = false;
  }

  showHelpPoints (points) {
    const len = points.length;

    let wait = 1000;
    const time = 1000;

    this.showHelperClick(points[0].x, points[0].y, time);

    /** @type {Phaser.Time.TimerEvent[]} */
    this.showHelpPointsTweens = [];
    for (let i = 1; i < len; i++) {
      this.showHelpPointsTweens.push(this.scene.time.delayedCall(wait, this.showHelperClick, [points[i].x, points[i].y, time], this));
      wait += time;
    }
  }

  showHelperClick (x1, y1, time, delay = 0) {
    this.helperHand.x = x1 - this.helperHand.width / 2;
    this.helperHand.y = y1 - this.helperHand.height / 2;

    this.helperHand.alpha = 0;
    this.helperHand.scale = 1.2;

    this.scene.tweens.killTweensOf(this.helperHand);
    ABCyaPhaser.Tweens.addTween(this.helperHand, time / 2, { alpha: 1, scale: 1, delay, completeDelay: 200 }, Phaser.Math.Easing.Linear, () => {
      ABCyaPhaser.Tweens.addTween(this.helperHand, 200, { alpha: 0, scale: 1.1 }, Phaser.Math.Easing.Quadratic.Out);
    });
  }

  stopHelpPoints () {
    this.showHelpPointsTweens?.forEach(tween => tween.remove());
    this.scene.tweens.killTweensOf(this.helperHand);
    this.helperHand.alpha = 0;
  }

  showHelper (x1, y1, x2, y2, time, delay = 0) {
    this.helperHand.x = x1;
    this.helperHand.y = y1;

    this.helperHand.alpha = 0;
    this.helperHand.scale = 1.2;

    this.scene.tweens.killTweensOf(this.helperHand);

    ABCyaPhaser.Tweens.addTween(this.helperHand, time / 2, { scale: 1, alpha: 1, delay }, Phaser.Math.Easing.Linear, () => {
      ABCyaPhaser.Tweens.addTween(this.helperHand, time, { x: x2, y: y2, completeDelay: 200 }, Phaser.Math.Easing.Quadratic.Out, () => {
        ABCyaPhaser.Tweens.addTween(this.helperHand, 200, { alpha: 0, scale: 1.1 }, Phaser.Math.Easing.Quadratic.Out);
      });
    });
  }

  showTabButtons (wait = 0) {
    this.btnStartOver.visible = true;
    this.btnPicture.visible = true;
    this.btnReady.visible = true;

    const time = 760;

    ABCyaPhaser.Tweens.addTween(this.btnStartOver, time, { y: this.btnStartOver.destY, delay: wait + time }, Phaser.Math.Easing.Bounce.Out);
    ABCyaPhaser.Tweens.addTween(this.btnPicture, time, { y: this.btnPicture.destY, delay: wait }, Phaser.Math.Easing.Bounce.Out);

    this.btnReady.scale = 0;
    ABCyaPhaser.Tweens.addTween(this.btnReady, time, { scale: this.readyScale }, Phaser.Math.Easing.Bounce.Out);
  }

  hideTabButtons () {
    this.btnStartOver.visible = false;
    this.btnPicture.visible = false;
    this.btnReady.visible = false;

    this.btnReady.scale = 0;
    this.btnStartOver.y = this.btnStartOver.startY;
    this.btnPicture.y = this.btnPicture.startY;
  }
}